import React from "react";
import { TopTrendingListLoaderTemplate } from "themes/administration/analytics/components";

function TopTrendingListLoader(props) {
    return <TopTrendingListLoaderTemplate {...props} />;
}

export default TopTrendingListLoader;
